import { render, staticRenderFns } from "./notaOdontologica.vue?vue&type=template&id=e4c90892&scoped=true"
import script from "./notaOdontologica.vue?vue&type=script&lang=js"
export * from "./notaOdontologica.vue?vue&type=script&lang=js"
import style0 from "./notaOdontologica.vue?vue&type=style&index=0&id=e4c90892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c90892",
  null
  
)

export default component.exports